export const MuiInput = {
  MuiInput: {
    styleOverrides: {
      root: {
        lineHeight: "24px",
      },
    },
  },
};
